import { render, staticRenderFns } from "./ReportDocumentsComponent.vue?vue&type=template&id=07caeec6&scoped=true&"
import script from "./ReportDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./ReportDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07caeec6",
  null
  
)

export default component.exports